import { HugeiconsIcon } from "@hugeicons/react";
import { Mail02Icon } from "@hugeicons-pro/core-solid-rounded";
import { Undo03Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonVariant } from "shared/components";

interface EmailPaymentPendingViewProps {
  isUpdatingPreferredCheckoutType: boolean;
  onCancel: () => void;
  onFinish: () => void;
}

export const EmailPaymentPendingView = ({
  isUpdatingPreferredCheckoutType,
  onCancel,
  onFinish
}: EmailPaymentPendingViewProps) => {
  return (
    <div>
      <div className="h-[calc(80vh-153px)] flex flex-col items-center justify-center space-y-6">
        <HugeiconsIcon
          icon={Mail02Icon}
          size={48}
          className="text-primary-500"
        />

        <div className="space-y-2 text-center">
          <h2 className="text-xl font-bold">
            Payment request sent to applicant
          </h2>
          <p className="text-base text-content-400">
            Reports will not run until the applicant pays for the application
          </p>
        </div>

        <Button
          HugeIcon={Undo03Icon}
          variant={ButtonVariant.BASE}
          loading={isUpdatingPreferredCheckoutType}
          onClick={onCancel}
        >
          Cancel
        </Button>
      </div>
      <div className="mt-auto py-4 px-6 flex justify-end border-t border-alpha-100 gap-2">
        <Button
          variant={ButtonVariant.PRIMARY}
          className="w-[125px]"
          onClick={() => onFinish()}
        >
          Finish
        </Button>
      </div>
    </div>
  );
};
